const Topbar = () => {
    return {
        open: null,
        timeout: null,
        hasDropdownActive: true,
        closeTimeout: null,
    };
};

export default Topbar;
